var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "this-is-an-example",
    domProps: { textContent: _vm._s(_vm.example && "Hello World") },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }